import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-acknowledge-dialog',
  templateUrl: './acknowledge-dialog.component.html',
  styleUrls: ['./acknowledge-dialog.component.scss']
  })

export class AcknowledgeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AcknowledgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  closeDialog(actionConfirmed: boolean): void {
    this.dialogRef.close(actionConfirmed);
  }
}
